import { ArticlesPreview } from '@app/components/previews/articles-preview'
import { PrimaryLocale } from '@app/components/primary-locale'
import { Binding } from '@app/lib/binding'
import { BackButton } from '@app/lib/buttons'
import {
	DataGrid,
	DataGridEnumColumn,
	DataGridHasOneColumn,
	DataGridLoader,
	DataGridPagination,
	DataGridQueryFilter,
	DataGridTable,
	DataGridTextColumn,
	DataGridToolbar,
} from '@app/lib/datagrid'
import { Slots } from '@app/lib/layout'

export default () => {
	return (
		<>
			<Binding>
				<div className="flex flex-col gap-12">
					<Slots.Title>Gated content submission list</Slots.Title>
					<Slots.Back>
						<BackButton />
					</Slots.Back>
					<>
						<DataGrid entities="GatedContentSubmission">
							<DataGridToolbar>
								<DataGridQueryFilter />
							</DataGridToolbar>
							<DataGridLoader>
								<DataGridTable>
									<DataGridEnumColumn header="Type" field="type" options={{ 'download': 'Download', 'link': 'Link' }} />
									<DataGridHasOneColumn header="Article" field="article">
										<PrimaryLocale>
											<ArticlesPreview />
										</PrimaryLocale>
									</DataGridHasOneColumn>
									<DataGridTextColumn header="Source (other than article)" field="sourceTitle" />
									<DataGridTextColumn header="Email" field="email" />
									<DataGridTextColumn header="Name" field="name" />
									<DataGridTextColumn header="Company name" field="companyName" />
								</DataGridTable>
							</DataGridLoader>
							<DataGridPagination />
						</DataGrid>
					</>
				</div>
			</Binding>
		</>
	)
}
